<template>
    <v-app id="inspire">
        <v-overlay :value="!dataLoaded" opacity="0" z-index="4">
            <v-progress-circular indeterminate size="64" color="primary"> </v-progress-circular>
        </v-overlay>
        <!-- <div class="text-center">
      <v-progress-circular
          indeterminate
          v-if="!dataLoaded"
          color="primary">
      </v-progress-circular>
    </div> -->
        <div v-if="dataLoaded && isLoggedin">
            <v-navigation-drawer v-model="drawer" :right="$vuetify.rtl" clipped app disable-resize-watcher>
                <template v-if="loggedInUser" v-slot:prepend>
                    <v-list-item two-line>
                        <v-list-item-content>
                            <v-list-item-title>{{ loggedInUser.name }}</v-list-item-title>
                            <v-list-item-subtitle>Logged In</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </template>

                <v-list dense>
                    <v-list-item v-for="(link, index) in links.filter((e) => e.authorization == true)" :key="index" link :to="link.to">
                        <v-list-item-action>
                            <v-icon>{{ link.icon }}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ link.title }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item link @click="openPasswordChangeDialog">
                        <v-list-item-action>
                            <v-icon>mdi-key</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t("NAV_CHANGE_PASSWORD") }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>

                    <v-list-item link @click="logout">
                        <v-list-item-action>
                            <v-icon>mdi-account-arrow-right</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>{{ $t("NAV_LOGOUT") }}</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>

            <v-app-bar app color="primary" dark :clipped-left="!$vuetify.rtl" :clipped-right="$vuetify.rtl" flat>
                <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
                <v-toolbar-title>{{ $t("APP_TITLE") }}</v-toolbar-title>
                <v-divider vertical class="mx-4"></v-divider>
                <v-select style="max-width: 300px" hide-details filled dense :items="workshops" item-value="id" :loading="loading.workshop" :menu-props="{ down: true, offsetY: true }" item-text="name" @click="getWorkShop" @change="dispatchChangeWorkshop" v-model="selectedWorkshopId"> </v-select>
                <v-spacer class="mx-2"></v-spacer>
                <v-select style="max-width: 150px" hide-details filled dense :items="locales" item-value="code" item-text="name" @change="changeLocale" v-model="localeSelect"> </v-select>
                <!-- <v-toolbar-title v-if="dataLoaded">{{ workshop.name }}</v-toolbar-title> -->
            </v-app-bar>
            <div class="fill-height">
                <v-content>
                    <v-container fluid>
                        <router-view></router-view>
                    </v-container>
                </v-content>
            </div>
        </div>

        <PasswordChangeDialog ref="passwordChangeDialog" />
    </v-app>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import PasswordChangeDialog from "../components/PasswordChangeDialog";
import i18n from "../plugins/i18n";
export default {
    name: "MainLayout",
    components: {
        PasswordChangeDialog,
    },
    props: {
        source: String,
    },
    data() {
        return {
            drawer: null,
            dataLoaded: false,
            selectedWorkshopId: null,
            localeSelect: null,
            loading: {
                workshop: false,
            },
        };
    },
    computed: {
        ...mapGetters("authentication", ["isLoggedin"]),
        ...mapState("authentication", ["loggedInUser", "workshopId", "authorizations"]),
        ...mapState("workshop", ["workshop", "workshops"]),
        ...mapState(["locales", "locale"]),
        links() {
            return [
                { title: this.$t("NAV_DASHBOARD"), to: "/", icon: "mdi-home", authorization: true },
                { title: this.$t("NAV_JOBCARDS"), to: "/jobcards", icon: "mdi-engine", authorization: this.authorizations.jobcards.read },
                { title: this.$t("NAV_WORKSHOPS"), to: "/workshops", icon: "mdi-office-building", authorization: this.authorizations.workshops.read },
                { title: this.$t("NAV_EXTERNAL_WORKSHOPS"), to: "/external-workshops", icon: "mdi-office-building", authorization: this.authorizations.external_workshops.read },
                { title: this.$t("NAV_TRUCK_TYPES"), to: "/truck-types", icon: "mdi-dump-truck", authorization: this.authorizations.truck_types.read },
                { title: this.$t("NAV_TRUCK_BRANDS"), to: "/truck-brands", icon: "mdi-dump-truck", authorization: this.authorizations.truck_brands.read },
                { title: this.$t("NAV_TRUCKS"), to: "/trucks", icon: "mdi-dump-truck", authorization: this.authorizations.trucks.read },
                { title: this.$t("NAV_DRIVERS"), to: "/drivers", icon: "mdi-face", authorization: this.authorizations.drivers.read },
                { title: this.$t("NAV_ITEM_GROUPS"), to: "/item-groups", icon: "mdi-circle", authorization: this.authorizations.item_groups.read },
                // { title: this.$t("FAILURES"), to: "/failure-master-view", icon: "mdi-format-wrap-inline", authorization: true },
                { title: this.$t("REPORTS"), to: "/reports", icon: "mdi-chart-areaspline", authorization: true },
                { title: this.$t("maintenance_report"), to: "/maintenance-report", icon: "mdi-chart-gantt", authorization: this.authorizations.maintenance_report.read },
                { title: this.$t("NAV_ITEMS"), to: "/items", icon: "mdi-circle", authorization: this.authorizations.items.read },
                { title: this.$t("NAV_TIRE_BRANDS"), to: "/tire-brands", icon: "mdi-circle", authorization: this.authorizations.tire_brands.read },
                { title: this.$t("NAV_USERS"), to: "/users", icon: "mdi-account", authorization: this.authorizations.users.read },
                { title: this.$t("NAV_PERMISSIONS"), to: "/permissions", icon: "mdi-key", authorization: this.authorizations.roles.read },
            ];
        },
    },
    methods: {
        ...mapActions("authentication", ["logout", "getCurrentUser", "fetchAuthorizations", "changeWorkshop"]),
        ...mapActions("workshop", ["fetchAll"]),
        ...mapActions(["setLocale"]),
        openPasswordChangeDialog() {
            this.$refs.passwordChangeDialog.open();
        },
        async dispatchChangeWorkshop() {
            this.dataLoaded = false;
            await this.changeWorkshop(this.selectedWorkshopId);
            this.$router.push("/");
            this.dataLoaded = true;
        },
        async fetchAfterLoginData() {
            this.dataLoaded = false;
            await this.getCurrentUser();
            await this.fetchAuthorizations(this.workshopId);
            this.dataLoaded = true;
        },
        changeLocale() {
            this.setLocale(this.localeSelect);
            this.$vuetify.rtl = this.locales.find((each) => each.code == this.locale).rtl;
            i18n.locale = this.locale;
        },
        async getWorkShop() {
            this.loading.workshop = true;
            if (this.workshops.length == 0) await this.fetchAll();
            this.loading.workshop = false;
        },
    },
    async created() {
        if (this.isLoggedin) {
            this.localeSelect = this.locale;
            this.$vuetify.rtl = this.locales.find((each) => each.code == this.locale).rtl;
            i18n.locale = this.locale;
            await this.getCurrentUser();
            await this.fetchAuthorizations(this.workshopId);
        }
        // await this.showWorkshop(this.workshopId);
        this.dataLoaded = true;
    },
    updated() {
        this.selectedWorkshopId = this.workshopId;
    },
};
</script>
